// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"fd135298","453":"9da13e97"}[chunkId] + ".chunk.js";
};